module.exports = __webpack_public_path__ + "img/gallery16.3ff086f1.png";